// src/services/constants/roleConstants.js
// Centralized role and permission constants

export const ROLES = {
    SUPER_ADMIN: 'super_admin',
    CREATOR: 'creator',
    SUPPORT: 'support',
    VIEWER: 'viewer'
};

export const PERMISSION_LEVELS = {
    DOWNLOAD: 3,   // View + Print + Download (highest level)
    PRINT: 2,      // View + Print (mid level)
    VIEW: 1,       // View only (lowest level)
    NONE: 0        // No access
};

export const PRODUCTS = {
    EQUITY_MANAGER: 'equity_manager',
    DATAROOM: 'dataroom',
    CAPRAISE: 'capraise'
};

export const ROLE_HIERARCHY = {
    [ROLES.SUPER_ADMIN]: 4,
    [ROLES.CREATOR]: 3,
    [ROLES.SUPPORT]: 2,
    [ROLES.VIEWER]: 1
};
